import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div
      className="Robustand robust_solution p-100"
      style={{ backgroundColor: "#F6F6F6" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>Kind of Music Apps We Develop</h2>
            <p>We develop all three types of music applications:</p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Connect!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Music Streaming Apps</h4>
                  <p>
                    These type of music applications are ones where the music is
                    present in the centralized databases of the service
                    provider/app owner. Sound cloud is a good example of what a
                    top music streaming app looks like. When developing music
                    streaming apps, we focus on the following components:
                  </p>
                  <ul>
                    <li>Music Discovery</li>
                    <li>Recommendations/Customization</li>
                    <li>Personal playlists</li>
                    <li>Sharing option for social media</li>
                  </ul>
                </div>
                <div className="robust-content">
                  <h4>Music Store Apps</h4>
                  <p>
                    These apps are very similar to music streaming apps, but
                    they have a commercial component to them. This effectively
                    means that we will build music apps for you that prioritize
                    monetization. Users will buy songs from these apps helping
                    you make in impressive revenue on a consistent basis. If you
                    want to conceptualize as to what kind of a music app these
                    look like, then imagine either Pandora or YouTube Music
                    which are both music store apps. In this app type, we focus
                    on these components:
                  </p>
                  <ul>
                    <li>Monetize/Paid Music</li>
                    <li>Specialized Promotions & Engagements</li>
                    <li>User reviews/feedback</li>
                  </ul>
                </div>
                <div className="robust-content">
                  <h4>Music Storage Apps</h4>
                  <p>
                    These music apps help users to play music stored on their
                    phones. Google Music, which is present on almost all Android
                    mobile phones, is an excellent example of music storage
                    apps. In this app genre, we focus more on functionality than
                    anything else in order to make incredibly efficient for
                    users to interact with these apps. The music player app
                    design is the main focus area for such type of apps. Music
                    storage apps are basically developed with the following
                    components:
                  </p>
                  <ul>
                    <li>External/Cloud Uploading</li>
                    <li>Personalization/Customization</li>
                    <li>Loop/Playback/Playlist Creation/Search Bar</li>
                  </ul>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
